// removed by extract-text-webpack-plugin
module.exports = {"LabelComp":"purify_LabelComp__LabelComp___8wPM2"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/LabelComp/LabelComp.scss
// module id = 260
// module chunks = 0